/* ltt-qty-cap — stops a shopper adding more than N of the SAME product.

   The rule and its copy are Liquid (snippets/ltt-qty-cap.liquid + the theme
   locales). This file owns no numbers and no strings: the ceiling, the exempt
   list and the refusal sentence all arrive in the `[data-ltt-cart-qty]` JSON
   the snippet renders. ltt-options.js once shipped an Arabic fallback string in
   the JS itself and the English store answered its shoppers in Arabic — that is
   the mistake this indirection exists to avoid.

   TWO HALVES, AND BOTH ARE NEEDED:
     • the CART, once it is already wrong — snippets/ltt-qty-cap.liquid draws
       the notice and assets/ltt-cart-cap.js refuses checkout on the shared
       `[data-ltt-cap-blocked]` flag.
     • the WAY IN, here — a submit that would push a product past the ceiling
       never leaves the browser, so the shopper is told before the cart moves
       rather than after.

   🔴 NEITHER HALF IS ENFORCEMENT. Cart Validation Functions are Plus-only and
   this store is not Plus, so a hand-crafted POST to /cart/add still lands.
   This is the shop assistant saying "that's the most we can send", not a lock.

   Delegated at document level, capture phase — the same reasoning as
   ltt-cart-cap.js and ltt-options.js. Capture runs before Dawn's own
   product-form submit handler, so the fetch never leaves; and the cart drawer's
   markup is replaced wholesale on every cart change, so per-element binding
   would be lost on the first add. */
(function () {
  'use strict';
  if (window.lttQtyCapBound) return;
  window.lttQtyCapBound = true;

  /* Read fresh on every check, never cached: the snippet's JSON node is
     replaced wholesale by the Section Rendering API on each cart change, so a
     reference captured at load would go stale on the first add. */
  function state() {
    var node = document.querySelector('[data-ltt-cart-qty]');
    if (!node) return null;
    try {
      var d = JSON.parse(node.textContent);
      if (!d || !(d.max > 0)) return null;
      return d;
    } catch (e) {
      /* Malformed JSON must not take add-to-cart down with it. No data, no cap
         — the cart notice and the checkout refusal are still there. */
      return null;
    }
  }

  function inCart(data, handle) {
    var total = 0;
    for (var i = 0; i < data.lines.length; i++) {
      if (data.lines[i][0] === handle) total += data.lines[i][1];
    }
    return total;
  }

  function exempt(data, handle, type) {
    if (type === 'noshow') return true;
    return data.excluded.indexOf(handle) !== -1;
  }

  /* The handle and the product type ride on the form. Every add-to-cart surface
     in this theme renders `data-ltt-handle` / `data-ltt-type`; a form without
     them (a Shopify app's, say) is left alone rather than guessed at. */
  function surface(form) {
    var host = form.closest('[data-ltt-handle]') || form.querySelector('[data-ltt-handle]');
    if (!host) return null;
    return { handle: host.getAttribute('data-ltt-handle'), type: host.getAttribute('data-ltt-type') || '' };
  }

  function wanted(form) {
    var field = form.querySelector('[name="quantity"]');
    if (!field) return 1;
    var n = parseInt(field.value, 10);
    return n > 0 ? n : 1;
  }

  /* The toast is assets/ltt-toast.js, shared with ltt-card-add.js. If it failed
     to load, the add is still refused — silently rather than rudely. Blocking
     without explaining is bad; adding a fifth unit because a cosmetic script
     is missing is worse. */
  function say(text) {
    if (typeof window.lttToast === 'function') window.lttToast(text);
  }

  /* Liquid hands the sentence over already interpolated, so there is nothing to
     substitute here and no format string living in two places. */
  function message(data) {
    return data.message || '';
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

      var data = state();
      if (!data) return;

      var who = surface(form);
      if (!who || exempt(data, who.handle, who.type)) return;

      if (inCart(data, who.handle) + wanted(form) <= data.max) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      say(message(data));
    },
    true
  );
})();
